export default __webpack_public_path__ + "static/media/degot-screenshot-03.e082117b.png";